import { call, put, takeLatest } from 'redux-saga/effects';

import authService from 'services/authService';

import { receiveAccessToken } from 'store/session/actions';

import { setToken } from 'utils/token';

import { types, changePassword } from './actions';

export default function* root() {
  yield takeLatest(types.CHANGE_PASSWORD_REQUEST, watchChangePassword);
}

function* watchChangePassword(action) {
  try {
    const { currentPassword, newPassword, newPasswordConf } = action.payload;
    const { token } = yield call(authService.changePassword, {
      currentPassword,
      newPassword,
      newPasswordConf,
    });
    yield call(setToken, token);
    yield put(changePassword.success());
    yield put(receiveAccessToken(token));
  } catch (error) {
    yield put(changePassword.error(error));
  }
}

export function* initSaga() {
  yield put(changePassword.init());
}
